import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import { InputText } from "primereact/inputtext";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import Loader from "../../Components/Loader";

const StockNorm = () => {
    const [divisonOpions, setDivisonOpions] = useState([]);
    const [selectedDivisonOpions, setSelectedDivisonOpions] = useState();
    const [quarterOpions, setQuarterOption] = useState([]);
    const [selectedQuarterOpions, setSelectedQuarterOpions] = useState();
    const [allstockNormData, setAllstockNormData] = useState();
    const [loadingExcelAll, setLoadingExcelAll] = useState(false);
    const [loading, setLoading] = useState(false);
    const auth = storage.getLocal("user");
    const [agreedstknorm, setAgreedstknorm] = useState("0");
    const [totNpinorm, setTotNpinorm] = useState("0");
    const [aplusnorm, setAplusnorm] = useState("0");
    const [balnorm, setBalnorm] = useState("0");

    let div_URL = "NewProdIntro/PopulateDivision?";
    let qtr_URL = "NewProdIntro/PopulateQuarter?";
    let stknorm = "StockNorm/GetAllStockNormData?";
    let alusnormdt = "StockNorm/GetAPlusNormData?";
    let npinormdt = "StockNorm/GetNPINormData?";
    let agrnormdt = "StockNorm/GetAgreedStkNormData?";
    let totltrs = "StockNorm/GetTotalInLtrs?";

    //   /api/StockNorm/GetAPlusNormData
    // /api/StockNorm/GetNPINormData
    // /api/StockNorm/GetAgreedStkNormData
    // /api/StockNorm/GetTotalInLtrs

    useEffect(() => {
        const div_api = `${div_URL}`;
        const qtr_api = `${qtr_URL}`;
        const pageonLoad = async () => {
            try {
                const div_res = await Axios.get(div_api);
                const qtr_res = await Axios.get(qtr_api);
                setDivisonOpions(div_res.data.Data);
                setSelectedDivisonOpions(div_res.data.Data[0]);
                setQuarterOption(qtr_res.data.Data);
                setSelectedQuarterOpions(qtr_res.data.Data[0]);
            } catch (error) {
                console.log(error);
            }
        };
        pageonLoad();
    }, []);
    const loadDataAll = async () => {
        try {
            setLoading(true);
            const [aplusnormdt, npinormDt, agreedstocknormDt, grtintotltr] =
        await Promise.all([
            Axios.get(
                `${alusnormdt}CompId=${auth.CompId}&strQtr=${selectedQuarterOpions?.QTR_ID}`
            ),
            Axios.get(
                `${npinormdt}CompId=${auth.CompId}&strQtr=${selectedQuarterOpions?.QTR_ID}`
            ),
            Axios.get(`${agrnormdt}CompId=${auth.CompId}`),
            Axios.get(
                `${totltrs}CompId=${auth.CompId}&strQtr=${selectedQuarterOpions?.QTR_ID}`
            ),
        ]);

            setAplusnorm(aplusnormdt?.data.Data?.APLUS_NORM ?? "0");
            setTotNpinorm(npinormDt?.data.Data[0]?.NPI_NORM ?? 0);
            setAgreedstknorm(agreedstocknormDt?.data.Data[0]?.AGREED_STOCK_NORM ?? 0);
            // setAdjSum(grtintotltr?.data.Data[0]?.ADJUSTED_STOCK_NORM_LTR ?? 0);
            // setFinalsum(grtintotltr?.data.Data[0]?.FINAL_STOCK_NORM_LTR ?? 0);
            console.log(grtintotltr?.data.Data[0]);
            let balnormsum =
        Number(agreedstocknormDt?.data.Data[0]?.AGREED_STOCK_NORM ?? 0) -
        Number(npinormDt?.data.Data[0]?.NPI_NORM ?? 0) -
        Number(aplusnormdt?.data.Data?.APLUS_NORM ?? 0);
            setBalnorm(balnormsum.toString());
        } catch (error) {
            console.error("Error fetching data:", error);
        }finally{
            setLoading(false);
        }
    };

    useEffect(() => {
        const quaterchnage = async () => {
            if (
                selectedQuarterOpions?.length !== 0 &&
        selectedDivisonOpions?.length !== 0
            ) {
                try {
                    setLoading(true);
                    const stkres = `${stknorm}CompId=${auth.CompId}&QtrId=${selectedQuarterOpions?.QTR_ID}`;
                    const stk_resdt = await Axios.get(stkres);
                    setAllstockNormData(stk_resdt.data.Data);
                    // console.log(stk_resdt.data);
                } catch (error) {
                    console.log(error);
                }finally{
                    setLoading(false);
                }
                loadDataAll();
            }
        };

        quaterchnage();
    }, [selectedQuarterOpions]);
    const handleExport = async () => {
        try {
            setLoadingExcelAll(true);
            const stkres = `${stknorm}CompId=${auth.CompId}&QtrId=${selectedQuarterOpions?.QTR_ID}`;
            const stk_resdt = await Axios.get(stkres);
            downloadExcel(stk_resdt.data.Data, `Stock_Norm_${GetDateFormat()}.xlsx`);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingExcelAll(false);
        }
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Stock Norm</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                title="Export"
                                className="btn btn-primary"
                                onClick={handleExport}
                                disabled={loadingExcelAll}
                            >
                                {loadingExcelAll ? "Loading..." : "Export"}{" "}
                                {loadingExcelAll ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaFileExport className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Division </label>
                                <Dropdown
                                    value={selectedDivisonOpions}
                                    onChange={(e) => {
                                        setSelectedDivisonOpions(e.value);
                                    }}
                                    options={divisonOpions}
                                    optionLabel="DIVN_NAME"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Quarter</label>
                                <Dropdown
                                    value={selectedQuarterOpions}
                                    onChange={(e) => {
                                        setSelectedQuarterOpions(e.value);
                                    }}
                                    options={quarterOpions}
                                    optionLabel="QTR_NAME"
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Agreed Stock Norm </label>
                                <InputText
                                    readOnly
                                    value={agreedstknorm}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Total NPI Norm</label>
                                <InputText
                                    readOnly
                                    value={totNpinorm}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">A+ Norm</label>
                                <InputText
                                    readOnly
                                    value={aplusnorm}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Balance Norm</label>
                                <InputText readOnly value={balnorm} className="form-control" />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="py-2">Records</h3>
                        <div className="DataTable">
                            {loading?<><Loader/></>:<DataTable
                                paginator
                                rows={10}
                                filterDisplay="row"
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                // showGridlines
                                scrollable
                                stripedRows
                                value={allstockNormData}
                                tableStyle={{ minWidth: "120rem" }}
                                emptyMessage="No Record found"
                            >
                                <Column
                                    field="PROD_CODE"
                                    header="Product Code"
                                    style={{ minWidth: "10rem" }}
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="PROD_DESC"
                                    header="Product Description"
                                    style={{ minWidth: "17rem" }}
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="CATEGORY"
                                    header="Category"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="AVG_DAILY_SALES"
                                    header="Weighted Average Daily Sales"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="STOCK_NORM"
                                    header="Stock Norm (Ltrs)"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="ADJ_STOCK_NORM"
                                    header="Adjusted Stock Norm (Case)"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="ADJUSTED_STOCK_NORM_LTR"
                                    header="Adjusted Stock Norm (Ltrs)"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="FINAL_STOCK_NORM"
                                    header="Final Stock Norm (Case)"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="FINAL_STOCK_NORM_LTR"
                                    header="Final Stock Norm (Ltrs)"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                                <Column
                                    field="TRANSIT_LEAD_TIME"
                                    header="Transit Lead Time"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                            </DataTable>}
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default StockNorm;
